import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.business.management');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-business-management',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.business.management/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminBusinessManagementComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public year: number = new Date().getFullYear();
    public years: number[] = Array.from({ length: 9 }, (_, i) => new Date().getFullYear() + 2 - i);
    public categories: any[] = [];
    public summaries: any[] = [];
    public entries: any[] = [];
    public linkedPrograms: any[] = [];
    public totalAmount: number = 0;
    public selectedCategory: string = '';
    public loading: boolean = false;
    public saving: boolean = false;
    public editingId: string = '';

    public entryForm: any = {
        category: 'support',
        title: '',
        revenue_amount: 0,
        revenue_date: new Date().toISOString().slice(0, 10),
        memo: ''
    };
    public editForm: any = {};

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("overview", { year: Number(this.year) || new Date().getFullYear() });
        if (code == 200) {
            this.year = Number(data.year) || this.year;
            this.categories = data.categories || [];
            this.summaries = data.summaries || [];
            this.entries = data.entries || [];
            this.linkedPrograms = data.linked_programs || [];
            this.totalAmount = Number(data.total_amount) || 0;
        } else {
            this.service.alert.error(data?.message || "사업관리 데이터를 불러오지 못했습니다.");
        }
        this.loading = false;
        await this.service.render();
    }

    public async moveYear(delta: number) {
        this.year = Number(this.year) + delta;
        if (!this.years.includes(this.year)) {
            this.years = Array.from(new Set([...this.years, this.year])).sort((a, b) => b - a);
        }
        await this.load();
    }

    public async selectCategory(key: string) {
        this.selectedCategory = this.selectedCategory === key ? '' : key;
        await this.service.render();
    }

    public visibleEntries(): any[] {
        if (!this.selectedCategory) return this.entries;
        return this.entries.filter((entry: any) => entry.category === this.selectedCategory);
    }

    public visibleLinkedPrograms(): any[] {
        if (!this.selectedCategory) return this.linkedPrograms;
        return this.linkedPrograms.filter((program: any) => program.category === this.selectedCategory);
    }

    public visibleRows(): any[] {
        const entries = this.visibleEntries().map((entry: any) => ({
            ...entry,
            row_type: 'manual',
            display_title: entry.title || '',
            display_period: entry.revenue_date || '-',
            display_amount: Number(entry.revenue_amount) || 0,
            display_note: entry.memo || '-',
            sort_date: entry.revenue_date || ''
        }));
        const programs = this.visibleLinkedPrograms().map((program: any) => ({
            ...program,
            id: `program-${program.id || program.source_id || program.title}`,
            row_type: 'linked',
            display_title: program.title || '',
            display_period: this.formatPeriod(program),
            display_amount: Number(program.amount) || 0,
            display_note: program.status || program.agency || program.program_category || '-',
            sort_date: program.program_start || program.program_end || ''
        }));
        return [...entries, ...programs].sort((a: any, b: any) => {
            const dateCompare = String(b.sort_date || '').localeCompare(String(a.sort_date || ''));
            if (dateCompare !== 0) return dateCompare;
            return String(a.display_title || '').localeCompare(String(b.display_title || ''));
        });
    }

    public summaryCount(item: any): number {
        return (Number(item?.manual_count) || 0) + (Number(item?.linked_count) || 0);
    }

    public categoryLabel(key: string): string {
        const found = this.categories.find((item: any) => item.key === key);
        return found ? found.label : key;
    }

    public badgeClass(key: string): string {
        const map: any = {
            support: 'border-emerald-200 bg-emerald-50 text-emerald-700',
            tips: 'border-amber-200 bg-amber-50 text-amber-700',
            open_innovation: 'border-blue-200 bg-blue-50 text-blue-700',
            consulting: 'border-zinc-200 bg-zinc-50 text-zinc-700'
        };
        return map[key] || map.consulting;
    }

    public dotClass(key: string): string {
        const map: any = {
            support: 'bg-emerald-500',
            tips: 'bg-amber-500',
            open_innovation: 'bg-blue-500',
            consulting: 'bg-zinc-500'
        };
        return map[key] || map.consulting;
    }

    public formatMoney(value: any): string {
        const amount = Number(value) || 0;
        return amount.toLocaleString();
    }

    public formatPeriod(row: any): string {
        const start = row?.program_start || '';
        const end = row?.program_end || '';
        if (start && end) return `${start} ~ ${end}`;
        return start || end || '-';
    }

    public resetForm() {
        this.entryForm = {
            category: this.selectedCategory || 'support',
            title: '',
            revenue_amount: 0,
            revenue_date: new Date().toISOString().slice(0, 10),
            memo: ''
        };
    }

    public async createEntry() {
        if (this.saving) return;
        this.saving = true;
        const payload = {
            category: this.entryForm.category || 'support',
            title: this.entryForm.title || '',
            revenue_amount: Number(this.entryForm.revenue_amount) || 0,
            revenue_date: this.entryForm.revenue_date || '',
            memo: this.entryForm.memo || ''
        };
        const { code, data } = await wiz.call("create_entry", payload);
        this.saving = false;
        if (code == 200) {
            this.service.alert.success("저장되었습니다.");
            this.resetForm();
            await this.load();
        } else {
            this.service.alert.error(data?.message || "저장하지 못했습니다.");
            await this.service.render();
        }
    }

    public startEdit(entry: any) {
        this.editingId = entry.id;
        this.editForm = {
            category: entry.category,
            title: entry.title,
            revenue_amount: Number(entry.revenue_amount) || 0,
            revenue_date: entry.revenue_date || '',
            memo: entry.memo || ''
        };
        this.service.render();
    }

    public cancelEdit() {
        this.editingId = '';
        this.editForm = {};
        this.service.render();
    }

    public async saveEdit(entry: any) {
        const payload = {
            id: entry.id,
            category: this.editForm.category || 'support',
            title: this.editForm.title || '',
            revenue_amount: Number(this.editForm.revenue_amount) || 0,
            revenue_date: this.editForm.revenue_date || '',
            memo: this.editForm.memo || ''
        };
        const { code, data } = await wiz.call("update_entry", payload);
        if (code == 200) {
            this.editingId = '';
            this.editForm = {};
            this.service.alert.success("저장되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(data?.message || "수정하지 못했습니다.");
        }
    }

    public async deleteEntry(entry: any) {
        const confirmed = await this.service.alert.show({
            title: '삭제',
            message: '선택한 매출 항목을 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        const { code, data } = await wiz.call("delete_entry", { id: entry.id });
        if (code == 200) {
            this.service.alert.success("삭제되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(data?.message || "삭제하지 못했습니다.");
        }
    }
}

export default PortalLpsysadminBusinessManagementComponent;